function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import HashSet from '../../../../../java/util/HashSet';
import Position from '../../geomgraph/Position';
import Stack from '../../../../../java/util/Stack';
import RightmostEdgeFinder from './RightmostEdgeFinder';
import TopologyException from '../../geom/TopologyException';
import LinkedList from '../../../../../java/util/LinkedList';
import Comparable from '../../../../../java/lang/Comparable';
import ArrayList from '../../../../../java/util/ArrayList';
import Envelope from '../../geom/Envelope';
var BufferSubgraph = /*#__PURE__*/function () {
  function BufferSubgraph() {
    _classCallCheck(this, BufferSubgraph);
    BufferSubgraph.constructor_.apply(this, arguments);
  }
  return _createClass(BufferSubgraph, [{
    key: "clearVisitedEdges",
    value: function clearVisitedEdges() {
      for (var it = this._dirEdgeList.iterator(); it.hasNext();) {
        var de = it.next();
        de.setVisited(false);
      }
    }
  }, {
    key: "getRightmostCoordinate",
    value: function getRightmostCoordinate() {
      return this._rightMostCoord;
    }
  }, {
    key: "computeNodeDepth",
    value: function computeNodeDepth(n) {
      var startEdge = null;
      for (var i = n.getEdges().iterator(); i.hasNext();) {
        var de = i.next();
        if (de.isVisited() || de.getSym().isVisited()) {
          startEdge = de;
          break;
        }
      }
      if (startEdge === null) throw new TopologyException('unable to find edge to compute depths at ' + n.getCoordinate());
      n.getEdges().computeDepths(startEdge);
      for (var _i = n.getEdges().iterator(); _i.hasNext();) {
        var _de = _i.next();
        _de.setVisited(true);
        this.copySymDepths(_de);
      }
    }
  }, {
    key: "computeDepth",
    value: function computeDepth(outsideDepth) {
      this.clearVisitedEdges();
      var de = this._finder.getEdge();
      var n = de.getNode();
      var label = de.getLabel();
      de.setEdgeDepths(Position.RIGHT, outsideDepth);
      this.copySymDepths(de);
      this.computeDepths(de);
    }
  }, {
    key: "create",
    value: function create(node) {
      this.addReachable(node);
      this._finder.findEdge(this._dirEdgeList);
      this._rightMostCoord = this._finder.getCoordinate();
    }
  }, {
    key: "findResultEdges",
    value: function findResultEdges() {
      for (var it = this._dirEdgeList.iterator(); it.hasNext();) {
        var de = it.next();
        if (de.getDepth(Position.RIGHT) >= 1 && de.getDepth(Position.LEFT) <= 0 && !de.isInteriorAreaEdge()) {
          de.setInResult(true);
        }
      }
    }
  }, {
    key: "computeDepths",
    value: function computeDepths(startEdge) {
      var nodesVisited = new HashSet();
      var nodeQueue = new LinkedList();
      var startNode = startEdge.getNode();
      nodeQueue.addLast(startNode);
      nodesVisited.add(startNode);
      startEdge.setVisited(true);
      while (!nodeQueue.isEmpty()) {
        var n = nodeQueue.removeFirst();
        nodesVisited.add(n);
        this.computeNodeDepth(n);
        for (var i = n.getEdges().iterator(); i.hasNext();) {
          var de = i.next();
          var sym = de.getSym();
          if (sym.isVisited()) continue;
          var adjNode = sym.getNode();
          if (!nodesVisited.contains(adjNode)) {
            nodeQueue.addLast(adjNode);
            nodesVisited.add(adjNode);
          }
        }
      }
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var graph = o;
      if (this._rightMostCoord.x < graph._rightMostCoord.x) {
        return -1;
      }
      if (this._rightMostCoord.x > graph._rightMostCoord.x) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "getEnvelope",
    value: function getEnvelope() {
      if (this._env === null) {
        var edgeEnv = new Envelope();
        for (var it = this._dirEdgeList.iterator(); it.hasNext();) {
          var dirEdge = it.next();
          var pts = dirEdge.getEdge().getCoordinates();
          for (var i = 0; i < pts.length - 1; i++) {
            edgeEnv.expandToInclude(pts[i]);
          }
        }
        this._env = edgeEnv;
      }
      return this._env;
    }
  }, {
    key: "addReachable",
    value: function addReachable(startNode) {
      var nodeStack = new Stack();
      nodeStack.add(startNode);
      while (!nodeStack.empty()) {
        var node = nodeStack.pop();
        this.add(node, nodeStack);
      }
    }
  }, {
    key: "copySymDepths",
    value: function copySymDepths(de) {
      var sym = de.getSym();
      sym.setDepth(Position.LEFT, de.getDepth(Position.RIGHT));
      sym.setDepth(Position.RIGHT, de.getDepth(Position.LEFT));
    }
  }, {
    key: "add",
    value: function add(node, nodeStack) {
      node.setVisited(true);
      this._nodes.add(node);
      for (var i = node.getEdges().iterator(); i.hasNext();) {
        var de = i.next();
        this._dirEdgeList.add(de);
        var sym = de.getSym();
        var symNode = sym.getNode();
        if (!symNode.isVisited()) nodeStack.push(symNode);
      }
    }
  }, {
    key: "getNodes",
    value: function getNodes() {
      return this._nodes;
    }
  }, {
    key: "getDirectedEdges",
    value: function getDirectedEdges() {
      return this._dirEdgeList;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BufferSubgraph;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }]);
}();
export { BufferSubgraph as default };
BufferSubgraph.constructor_ = function () {
  this._finder = null;
  this._dirEdgeList = new ArrayList();
  this._nodes = new ArrayList();
  this._rightMostCoord = null;
  this._env = null;
  this._finder = new RightmostEdgeFinder();
};